import React from 'react';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';
import query, {
    UserBlogLikersLoaderQuery,
    UserBlogLikersLoaderQueryVariables,
} from './user-blog-likers-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
}

class UserBlogLikersDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { id, open, onClose } = this.props;
        return (
            <Modal title={<FormattedMessage id='SUBSCRIBERS' />} open={open} onClose={onClose}>
                <Query<UserBlogLikersLoaderQuery, UserBlogLikersLoaderQueryVariables>
                    query={query}
                    variables={{ id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.photoBlog && data.photoBlog.likers ? (
                                    <LikersList {...data.photoBlog} />
                                ) : null}
                                {data &&
                                data.photoBlog &&
                                data.photoBlog.likers &&
                                data.photoBlog.likers.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.photoBlog &&
                                                data.photoBlog.likers &&
                                                data.photoBlog.likers.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as UserBlogLikersLoaderQuery,
                                                    { fetchMoreResult = {} as UserBlogLikersLoaderQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        photoBlog: {
                                                            ...(previousResult && previousResult.photoBlog),
                                                            ...(fetchMoreResult && previousResult.photoBlog),
                                                            likers: mapAfter(
                                                                previousResult.photoBlog &&
                                                                    previousResult.photoBlog.likers,
                                                                fetchMoreResult.photoBlog &&
                                                                    fetchMoreResult.photoBlog.likers
                                                            ),
                                                        },
                                                    } as UserBlogLikersLoaderQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default Styled({})(UserBlogLikersDialog);
